export const environment = {
    production: true,
    apiUrl: 'https://backend-demo.imagineapps.co'
  };